/**
 * This plugins provides icon definitions by use case
 * Names must be from the list of [Material Design Icons](http://material.io/tools/icons)
 */
const icons = {
  email: {
    default: 'email',
    send: 'send',
  },
  sort: {
    default: 'import_export',
    desc: 'arrow_downward',
    asc: 'arrow_upward',
  },
  add: {
    default: 'add',
    multiple: 'playlist_add',
    person: 'person_add',
  },
  edit: {
    default: 'edit',
    details: 'settings',
    builder: 'extension',
  },
  date: {
    start: 'today',
    end: 'event',
    schedule: 'schedule',
  },
  remove: {
    default: 'delete',
  },
  entity: {
    currentUser: 'accessibility_new',
    otherUser: 'accessibility',
    info: 'info',
    authorizers: 'supervisor_account',
    table: 'table_chart',
    pin: 'push_pin',
  },
  search: {
    submit: 'arrow_forward',
  },
  admin: {
    page: 'build',
    account: 'vpn_key',
  },
  arrow: {
    left: 'arrow_back',
    right: 'arrow_forward',
    up: 'arrow_upward',
    down: 'arrow_downward',
  },
  reset: {
    default: 'replay',
  },
  status: {
    warn: 'warning',
    success: 'check',
    noConnection: 'cloud_off',
    included: 'check_circle',
    excluded: 'remove_circle',
  },
  notification: {
    enabled: 'notification_important',
    disabled: 'add_alert',
  },
  filter: {
    greater: 'arrow_forward_ios',
    less: 'arrow_back_ios',
    empty: 'block',
    equal: 'filter_list_alt',
  },
  page: {
    home: 'home',
    details: 'list',
    audit: 'assignment',
  },
  export: {
    default: 'save_alt',
  },
  archive: {
    default: 'archive',
  },
  history: {
    default: 'history',
    status: 'featured_play_list',
  },
};

export default {
  install(Vue) {
    Vue.prototype.SbIcons = icons;
  },
  icons,
};
